import React from "react";
import {
  Body,
  Button,
  ButtonLayout,
  Modal
} from "@common/AggregationComponent";
import { useDispatch, useSelector } from "react-redux";
import { BRAND_LIST, CombinedReducersType } from "@type/index";
import { AppActions } from "@redux/reducer";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import { getEcRenewalCompatibility } from "@util/common";

const LoginModal = (): any => {
  const dispatch = useDispatch();
  const appStore = useSelector((state: CombinedReducersType) => state.app);
  const { region, language, brand_name } = appStore;
  const { t } = useTranslation();
  const [, setCookie] = useCookies();

  // redirectDomain
  const jumpDomain = (brand: string): string => {
    switch (brand) {
      case BRAND_LIST.GU:
        return window.location.origin.replace("gu-global", "uniqlo");
      default:
        return window.location.origin;
    }
  };

  const handlerJumpLogin = () => {
    const url = `${window.location.pathname}${window.location.search}`;

    setCookie("loginRedirectUri", url, {
      path: `/${region}`
    });
    dispatch(AppActions.setLoginModal(false));
    const _url = `${jumpDomain(
      brand_name.toLowerCase()
    )}/${region}/api/commerce/v5/${language}/redirect?from=${
      window.location.href
    }&to=${
      window.location.origin
    }/${region}/api/commerce/v5/${language}/connect`;
    window.location.href = _url;
  };

  const handlerClose = () => {
    dispatch(AppActions.setLoginModal(false));
  };

  return (
    <Modal
      closeTitle={t("text_a11y_close")}
      closeLabel={getEcRenewalCompatibility() ? " " : t("text_a11y_close")}
      errors={[]}
      id="sm-1"
      labelElement="h5"
      onBackdropClick={undefined}
      onRequestClose={handlerClose}
      title={t("text_login")}
      titleId="modal-title"
      trapFocus
      variant="small"
      isOpen
      footer={
        <ButtonLayout reverseOnVertical={false} variant="fluid">
          <Button
            element="button"
            isSmall={false}
            variant="primary"
            width="fullWidth"
            onClick={handlerJumpLogin}
          >
            {t("text_log_in")}
          </Button>
          <Button
            element="button"
            isSmall={false}
            variant="secondary"
            width="fullWidth"
            onClick={handlerClose}
          >
            {t("text_app_update_dialog_cancel")}
          </Button>
        </ButtonLayout>
      }
    >
      <Body element="p" variant="standard">
        {t("text_wish_list_login_required")}
      </Body>
    </Modal>
  );
};

export default LoginModal;
